// PLUGINS IMPORTS //
import React, { useState, useEffect, memo } from 'react'
import styled, { keyframes } from 'styled-components/macro'
// @ts-ignore
import TextTransition, { presets } from 'react-text-transition'
import { Link } from 'react-router-dom'

// COMPONENTS IMPORTS //
import SocialMediaSection from 'Content/Shared/Components/Sections/SocialMediaSection/SocialMediaSection'
import { Button } from 'Content/Shared/Components/Elements'

import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { H1, MediumText } from 'Content/Shared/Styles/TextStyles'
import { iPhoneResolution } from 'Content/Shared/Styles/Theme'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const titles = [
  'JavaScript developer',
  'TypeScript developer',
  'React JS developer',
  'React Native developer',
  'Node JS developer',
  'Swift UI developer',
]

const TitleSection: React.FC<PropsType> = () => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    setInterval(() => {
      setIndex((prev) => prev + 1)
    }, 2000)
  }, [])

  return (
    <Wrapper>
      <Title>
        Hi, I am Artem
        <TextTransition
          text={titles[index % titles.length]}
          springConfig={presets.wobbly}
        />
      </Title>
      <Description>
        Self-taught Full-Stack JavaScript & Swift developer with over 1 year of
        experience in building frontend, backend and mobile applications.
      </Description>
      <ButtonsWrap>
        <Link to={'/portfolio'}>
          <Button title={'My portfolio'} />
        </Link>
        <Link to={'/me'}>
          <Button title={'About me'} />
        </Link>
        <Link to={'/blog'}>
          <Button title={'Blog'} />
        </Link>
        <Link to={'/contacts'}>
          <Button title={'Contacts'} />
        </Link>
      </ButtonsWrap>
      <SocialWrap>
        <SocialMediaSection />
      </SocialWrap>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const animation = keyframes`
  from { opacity: 0; transform: translateY(-10px); filter: blur(10px);  }
  to { opacity: 1; transform: translateY(0px); filter: blur(0px); }
`

const Wrapper = styled.div`
  max-width: 500px;
  display: grid;
  gap: 30px;
  text-align: left;

  > * {
    opacity: 0;
    animation: ${animation} 1s 0.2s forwards;

    :nth-child(1) {
      animation: ${animation} 1s 0s forwards;
    }
    :nth-child(2) {
      animation: ${animation} 1s 0.4s forwards;
    }
    :nth-child(3) {
      animation: ${animation} 1s 0.6s forwards;
    }
  }
`

const Title = styled(H1)`
  color: white;
  background: linear-gradient(180deg, #730040 0%, #301cbe 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;

  div {
    background: linear-gradient(180deg, #ffd7ff 0%, #ffb6ff 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    font-size: 36px;
  }

  @media (max-width: ${iPhoneResolution}px) {
    font-size: 42px;

    div {
      margin-top: 3px;
      font-size: 26px;
    }
  }
`

const Description = styled(MediumText)`
  width: 106%;
`

const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  width: 90%;
`

const SocialWrap = styled.div`
  position: absolute;
  bottom: 3.5%;
  margin-left: -15px;

  @media (max-width: ${iPhoneResolution}px) {
    bottom: 2%;
  }
`

export default memo(TitleSection, memoComparison)
